import styled from 'styled-components';
import { Button } from '@zillow/constellation';

export const StyledDiv = styled.div`
    position: absolute;
    background-color: white;
    z-index: 99;
    left: 0;
    right: 0;
    text-align: center;
    top: 56px;
    bottom: 0;
    overflow: scroll;
    padding-top: 30px;
`;

export const StyledAutoHeightButton = styled(Button)`
    & {
        height: auto;
    };
`;
